import { asGroupedFieldOptionsForFilter } from 'module/helpers/filter/grouped-field-transformer';
import { useTranslate } from 'module/hooks/use-translation';
import { FilterableField } from 'module/types/filter-field/field/filterable-field';
import { GroupedOptions } from 'module/types/filter-field/field/grouped-field';
import { FilterGroupType } from 'module/types/filter-field/grouped-filter/group';
import { GroupFieldsMeta } from 'module/types/filter-field/transformer/filter-transformer';
import { useCompanyFieldsAsFilterableField } from 'helpers/fields/company-fields/fields';
import { keyBy } from 'lodash';
import { useMemo } from 'react';

export const useAiPagesFields = (): {
  fields: GroupedOptions<FilterableField>[];
  lookups: GroupFieldsMeta;
  isLoading: boolean;
} => {
  const { fields: companyFields, loading: isCompanyFieldsLoading } =
    useCompanyFieldsAsFilterableField();
  const companyFieldsLookup = useMemo(() => {
    return keyBy(companyFields, 'fieldName');
  }, [companyFields]);
  const translate = useTranslate();
  const fields = useMemo(
    () =>
      asGroupedFieldOptionsForFilter(
        {
          [FilterGroupType.Company]: {
            fields: companyFields,
          },
        },
        translate,
      ),
    [companyFields, translate],
  );
  const lookups: GroupFieldsMeta = useMemo(() => {
    return [
      {
        id: FilterGroupType.Company,
        fields: companyFieldsLookup,
      },
    ];
  }, [companyFieldsLookup]);

  return useMemo(
    () => ({
      isLoading: isCompanyFieldsLoading,
      fields,
      lookups,
    }),
    [isCompanyFieldsLoading, fields, lookups],
  );
};
